import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { LicenseService } from 'src/app/license/services/license.service';

@Injectable({
  providedIn: 'root',
})
export class LicenseGuard implements CanActivate {
  constructor(private licenseService: LicenseService, private router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    // condicion para controlar la ejecución de salida del guard
    const access_token = localStorage.getItem('auth.access_token');
    if (!access_token) {
      return true;
    }

    const existingPermissionList = localStorage.getItem('PermissionList');

    return this.licenseService.checkLicense().then((license) => {
      console.log('(LICENSE) verificacion desde el guard!!!', license);
      // Empezamos validacion cada 1 hora
      this.licenseService.startPeriodicCheck(3600000);
      if (license.isLicenseValid && license.remainingTime > 0) {
        return true;
      } else {
        if (!existingPermissionList) {
          return true;
        }
        const content: string[] = JSON.parse(existingPermissionList ?? '[]');
        if (!content.some((permission) => permission === 'license_module')) {
          console.log(
            '(LICENSE) no tiene permisos habilitados este usuario guard'
          );
          return true;
        }

        return this.router.createUrlTree(['/license']);
      }
    });
  }
}
